var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 313,
    viewBox: "0 0 361 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.073 102.906C217.453 102.906 191.405 101.894 167.011 95.091C142.617 88.2877 121.227 75.5699 101.522 60.6763C88.712 50.9617 77.0055 43.2697 60.3958 44.4342C44.1145 45.2931 28.5434 51.3754 15.9907 61.7795C-5.18527 80.1667 -1.96751 114.581 6.4906 138.699C19.2084 175.014 57.8522 200.235 90.8572 216.692C128.888 235.692 170.535 246.724 212.55 253.068C249.324 258.645 296.426 262.69 328.236 238.726C357.472 216.692 365.501 166.403 358.33 132.417C356.548 122.434 351.201 113.439 343.283 107.104C322.781 92.1184 292.136 102.139 269.09 102.63C260.51 102.66 251.807 102.875 243.073 102.906Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.141 12.7776H49.151C41.5686 12.7776 35.4219 18.9243 35.4219 26.5067V216.048C35.4219 223.63 41.5686 229.777 49.151 229.777H314.141C321.724 229.777 327.87 223.63 327.87 216.048V26.5067C327.87 18.9243 321.724 12.7776 314.141 12.7776Z",
    fill: "white",
    stroke: "#636363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 209.582H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 175.259H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 140.967H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 106.644H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 72.3215H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2988 37.9985H307.918",
    stroke: "#CDCDCD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5056 60.3391H80.2829C76.1194 60.3391 72.7441 63.7143 72.7441 67.8779V203.882C72.7441 208.045 76.1194 211.421 80.2829 211.421H97.5056C101.669 211.421 105.044 208.045 105.044 203.882V67.8779C105.044 63.7143 101.669 60.3391 97.5056 60.3391Z",
    fill: "#8D8D8D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159.347 119.27H142.125C137.961 119.27 134.586 122.645 134.586 126.809V203.882C134.586 208.045 137.961 211.42 142.125 211.42H159.347C163.511 211.42 166.886 208.045 166.886 203.882V126.809C166.886 122.645 163.511 119.27 159.347 119.27Z",
    fill: "#8D8D8D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M221.164 76.1523H203.941C199.778 76.1523 196.402 79.5276 196.402 83.6911V203.851C196.402 208.015 199.778 211.39 203.941 211.39H221.164C225.327 211.39 228.703 208.015 228.703 203.851V83.6911C228.703 79.5276 225.327 76.1523 221.164 76.1523Z",
    fill: "#8D8D8D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.972 140.354H265.75C261.586 140.354 258.211 143.729 258.211 147.893V203.851C258.211 208.015 261.586 211.39 265.75 211.39H282.972C287.136 211.39 290.511 208.015 290.511 203.851V147.893C290.511 143.729 287.136 140.354 282.972 140.354Z",
    fill: "#8D8D8D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2773 128.249L92.2355 127.544L142.524 179.243L190.638 135.42L243.072 152.673L293.667 120.373",
    stroke: "#636363",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.049 247.153V260.331",
    stroke: "#636363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.461 253.742H114.638",
    stroke: "#636363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343.746 73.731V86.9084",
    stroke: "#636363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M337.15 80.3198H350.328",
    stroke: "#636363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.597 189.632C20.2556 189.632 21.6002 188.287 21.6002 186.628C21.6002 184.97 20.2556 183.625 18.597 183.625C16.9384 183.625 15.5938 184.97 15.5938 186.628C15.5938 188.287 16.9384 189.632 18.597 189.632Z",
    fill: "#777777"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.245 312.55C255.275 312.55 305.56 309.422 305.56 305.563C305.56 301.704 255.275 298.576 193.245 298.576C131.215 298.576 80.9297 301.704 80.9297 305.563C80.9297 309.422 131.215 312.55 193.245 312.55Z",
    fill: "#CDCDCD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M301.518 0.550049L332.439 31.5018",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no-data-available.78e08d6ccb7ffc5d3a9467933dc4fd21.svg";
export { ForwardRef as ReactComponent };